<div class="inline-number-wrapper" [ngClass]="{ 'fixed-height': isFixedHeight }">
  @if (!isEditing) {
    <span class="left">
      @if (!value) {
        <a (click)="startEdit()" class="add"> {{ addText }} </a>
      }
      @if (value && !mask) {
        <span>
          {{ value }}
        </span>
      }
      @if (value && mask) {
        <span>
          {{ value | mask: mask }}
        </span>
      }
      @if (value) {
        <button class="edit-button" mat-icon-button (click)="startEdit()">
          <mat-icon class="edit-icon">edit</mat-icon>
        </button>
      }
    </span>
  }
  <div
    class="editing"
    [ngClass]="{
      hidden: !isEditing,
    }"
  >
    <form>
      <mat-form-field [appearance]="isFixedHeight ? 'fill' : 'outline'">
        <input
          matInput
          class="editable"
          name="value"
          [formControl]="textInputControl"
          [required]="required"
          [placeholder]="placeholder"
          #editInput
          [(ngModel)]="pendingValue"
          (keydown.enter)="confirmEdit()"
          (keydown.escape)="cancelEdit()"
          [mask]="mask"
          [maxlength]="maxLength"
        />
      </mat-form-field>
    </form>
    <div class="button-container">
      @if (maxLength) {
        <mat-hint class="char-limit button-text">{{ editInput?.value?.length || 0 }}/{{ maxLength }}</mat-hint>
      }
      <button mat-button (click)="cancelEdit()">CANCEL</button>
      <button
        mat-button
        color="primary"
        class="save"
        [disabled]="(required && !pendingValue) || textInputControl.invalid"
        (click)="confirmEdit()"
      >
        SAVE
      </button>
    </div>
  </div>
</div>
